import { useNavigate, Navigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-toastify";
import BackgroundComponent from "../../components/background";
import LoadingModalComponent from "../../modals/loading-modal";
import { signIn } from "../../api/services";

export default function LoginScreen() {
  const navigate = useNavigate();
  const [loginInfo, setLoginInfo] = useState({ name: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const isLoggedIn = localStorage.getItem("token");

  const login = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await signIn(loginInfo.name, loginInfo.password);
      localStorage.setItem("name", res.data.name);
      localStorage.setItem("token", res.data.token);
      toast.success(`Сайн уу, ${res.data.name}!`);
      navigate("/e/list");
    } catch (err) {
      toast.error(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) => {
    setLoginInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  if (isLoggedIn) {
    return <Navigate replace={true} to={{ pathname: "/e/list" }} />;
  }

  return (
    <div>
      <LoadingModalComponent show={loading} />
      <BackgroundComponent />
      <div className="account-pages">
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-xxl-4 col-lg-5"
              style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="card">
                <div className="card-header py-4 text-center border-bottom">
                  <a href="index.html">
                    <span>
                      <img src="assets/images/logo.png" alt="logo" height={66} />
                    </span>
                  </a>
                </div>
                <div className="card-body p-4">
                  <div className="text-center w-75 m-auto">
                    <h4 className="text-dark-50 text-center pb-0 fw-bold">НЭВТРЭХ</h4>
                    <p className="text-muted mb-4">
                      Бүртгэлтэй нэвтрэх нэр болон нууц үгээ оруулан нэвтэрнэ үү
                    </p>
                  </div>
                  <form action="#">
                    <div className="mb-3">
                      <label htmlFor="userName" className="form-label">Нэвтрэх нэр</label>
                      <input
                        className="form-control"
                        type="text"
                        id="userName"
                        name="name"
                        required
                        placeholder="Нэвтрэх нэрээ оруулна уу"
                        onChange={onChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">Нууц үг</label>
                      <div className="input-group input-group-merge">
                        <input
                          required
                          type={showPassword ? "text" : "password"}
                          id="password"
                          name="password"
                          className="form-control"
                          placeholder="Нууц үгээ оруулна уу"
                          onChange={onChange}
                        />
                        <div
                          className={`input-group-text ${showPassword ? "show-password" : ""}`}
                          data-password="false"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <span className={"password-eye"} />
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="form-check">
                        <input type="checkbox" className="form-check-input" id="checkbox-signin" defaultChecked />
                        <label className="form-check-label" htmlFor="checkbox-signin">Сануулах</label>
                      </div>
                    </div>
                    <div className="mb-3 mb-0 text-center">
                      <button className="btn btn-primary" type="submit" onClick={login}>
                        <i className="mdi mdi-login me-1" /> Нэвтрэх
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <p className="my-auto"> ©2024 | Powered by </p>
                <img className="rounded ms-2" src="/assets/images/e24.png" width={20} height={20} />
                <p className="ms-1 my-auto">E24</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
